import { render, staticRenderFns } from "./WizardStepIndicator.vue?vue&type=template&id=ec151e36&scoped=true"
import script from "./WizardStepIndicator.vue?vue&type=script&lang=js"
export * from "./WizardStepIndicator.vue?vue&type=script&lang=js"
import style0 from "./WizardStepIndicator.vue?vue&type=style&index=0&id=ec151e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec151e36",
  null
  
)

export default component.exports